import React from 'react'
import styles from './style.module.scss'

function Footer() {
  return (
    <div>
      <div className={styles.PCFooterContainer}>
        <div className={styles.Split}>
          <div className={styles.LogoWrap}>
            <img src="/logo_white.png" alt="logo" />
          </div>
        </div>
      </div>
      <div className={styles.MobileFooterContainer}>
        <div className={styles.Item}>
          Copyright © 2013 - 2024 All Rights Reserved Huanle Entertainment
        </div>
      </div>
    </div>
  )
}

export default React.memo(Footer)
